import { Button, Divider, Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import genericPage from '../../assets/images/genericPage.png';
import { StyledTitle } from '../../components/StyledTitle';
import { useLoaderContext } from '../../contexts/LoaderContext';

export const LoginPage: React.FC = () => {

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
    }, []);

    return (
        <Grid height="100%" container>
            {matches && (
                <Grid sm={5} sx={{ backgroundColor: '#E5EAF0', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                    <img src={genericPage} width="450" alt='genericPage' />
                </Grid>
            )}
            <Grid
                sm={matches ? 7 : 12}
                sx={{
                    background: "#fff"
                }}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        ACCEDI!
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <Box sx={{ padding: '0px 32px' }}>
                        <Button variant="contained" color="primary" onClick={() => {
                            const urlParams = new URLSearchParams(window.location.search);
                            const token = urlParams.get("token");
                            window.location.href = window.location.origin + "?token=" + token;
                        }}>
                            Accedi
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};
